export default __webpack_public_path__ + "static/media/MapStep2Vector.c8d9f736.svg";